var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hs-input"},[_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"blur":_vm.returnValue,"click":_vm.resetValue,"input":_vm.wrapValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }